import AuthSerivce from '@/@http/auth/auth.service';
import axios from 'axios';
import { DOMAIN } from '../apis';
import store from "@/store";

export default axios.interceptors.request.use((request) => {
    const auth = new AuthSerivce();
    const token = auth.getToken();
    if (token) {
        request.headers.Authorization = token;
    }
    if (request.url && request.url.indexOf('http') === -1) {
        request.url = `${DOMAIN}${request.url}`;
    }

    return request;
}, (error) => {
    return Promise.reject(error);
});
